import { Box, Skeleton } from "@mui/material"

const AllContactsGroupSkeleton=()=>{

    const skeletonCards = Array(8).fill(null);

    return (
        <Box sx={{width:"100%", padding:"5%"}}>
          <Box sx={{ ml: "65%", mb:"3%" }}>
                <Skeleton width="70%" />
            </Box>
            <Box sx={{ 
            width: "90%",
            display: "grid", 
            gridTemplateColumns: "repeat(4, 1fr)", 
            gap: "10px", 
            justifyItems: "left"
        }}>
            {skeletonCards.map((_, index) => (
                <Box key={index}>
                    <Box sx={{ pt: 0.5 }}>
                        <Skeleton />
                        <Skeleton width="60%" />
                    </Box>
                    <Skeleton variant="rectangular" width={180} height={180} />
                </Box>
            ))}
        </Box>
     </Box>
    )

}

export default AllContactsGroupSkeleton